import { DataGridTypes } from "devextreme-react/cjs/data-grid";
import { GridColumnNames } from "../../../../shared/constants";
import { Utilities } from "../../../../shared/utils/utilities";
import { DateTimeFormatStrings } from "../../../../shared/enums";

const DataGridCustomizeCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {
  const dataField = cellData.column.dataField;
  if (dataField === GridColumnNames.ValidFrom || dataField === GridColumnNames.ValidTo) {
    return <div>{Utilities.formatDate(new Date(cellData.value), DateTimeFormatStrings.FORMAT_7)}</div>;
  }

  return <div>{cellData.value}</div>;
};

export default DataGridCustomizeCell;
